import { DifferentiationResult } from "@/services/backend/differentiation/differentiation";
import { Procedure } from "@/services/backend/procedures/procedure/procedure";
import { EvaluableType } from "@/services/backend/sample-error/sample-error";
import { GrowthMedium } from "@/services/backend/types";

export function getMouldCount(procedure: Procedure): number {
  let count = 0;
  const incubations = procedure.incubation.filter(
    (inc) => inc.growthMedium !== GrowthMedium.Caso,
  );

  incubations.forEach((inc) => {
    inc.measurements.forEach((measure) => {
      if (measure.isCurrent) {
        count += measure.measurement ? measure.measurement : 0;
      }
    });
  });

  return count;
}

export function getDifferentiatedCount(
  results: DifferentiationResult[],
): number {
  let count = 0;
  results.forEach((res) => {
    if (res.value != null) {
      count += res.value;
    }
  });
  return count;
}

export function checkIfNotEvaluable(procedure: Procedure): boolean {
  const nonCasoIncubations = procedure.incubation.filter(
    (inc) => inc.growthMedium !== GrowthMedium.Caso,
  );
  return nonCasoIncubations.some(
    (inc) => inc.evaluableType === EvaluableType.NotEvaluable,
  );
}

export function checkIfThresholdIsExceeded(procedure: Procedure): boolean {
  let threshold = false;
  procedure.incubation.forEach((inc) => {
    if (
      inc.growthMedium === GrowthMedium.Malt ||
      inc.growthMedium === GrowthMedium.DG18
    ) {
      inc.measurements.forEach((measure) => {
        if (measure.isCurrent && measure.exceedsThreshold) {
          threshold = true;
        }
      });
    }
  });

  return threshold;
}
